<template>
  <div class="mx-4 my-6 flex h-full flex-col">
    <div class="bg-white">
      <lf-h4 class="rounded-sm border-b p-5">
        {{ $t("ORCHESTRATION.CONFIGURE") }}
      </lf-h4>
      <div class="flex flex-col space-y-3 px-5 py-6">
        <label
          v-for="(value, key) in triggers?.attributes"
          :key="key"
          class="flex cursor-pointer items-start space-x-2"
          :class="{
            'cursor-not-allowed opacity-50': isActiveTemplatePublished,
            'cursor-pointer': !isActiveTemplatePublished,
          }"
        >
          <input
            type="radio"
            class="form-radio cursor-pointer"
            :class="{
              'cursor-not-allowed text-gray-400': isActiveTemplatePublished,
              'cursor-pointer': !isActiveTemplatePublished,
            }"
            name="triggerType"
            :value="value.id"
            :checked="isTriggerTypeChecked(value.id)"
            :disabled="isActiveTemplatePublished"
            @input="setTrigger(value.id)"
          />

          <div class="-mt-1 flex flex-col">
            <lf-h4>{{ value.title }}</lf-h4>
            <span>{{ value.info }}</span>
          </div>
        </label>
      </div>
    </div>
  </div>

  <div v-if="!isActiveTemplatePublished" class="flex bg-white px-6 py-5">
    <color-button type="unselected" class="w-full" @click="onSave">
      {{ $t("COMMON.SAVE") }}
    </color-button>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";

import {
  useDoActiveTemplateStatus,
  useDoActiveTemplateTrigger,
} from "@/hooks/orchestration";

import type { IDataService } from "@/models/orchestration";

const { getters, dispatch } = useStore();
const { trigger } = useDoActiveTemplateTrigger();
const { isActiveTemplatePublished } = useDoActiveTemplateStatus();

const updatedTriggerType = ref(trigger.value);

const triggers = computed<IDataService>(
  () => getters["orchestration/triggers"]
);

const setTrigger = (triggerId: string) => {
  updatedTriggerType.value = triggerId;
};

const onSave = () => {
  dispatch("orchestration/updateTrigger", updatedTriggerType.value);
};

const isTriggerTypeChecked = (typeId: string) => {
  return updatedTriggerType.value === typeId;
};
</script>
